import React from 'react';
import { Star, TrendingUp, Award, Users } from 'lucide-react';

const RatingSection = () => {
  const rating = 4.5;
  const totalReviews = 590;

  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <Star key={`full-${i}`} className="star-icon filled" fill="currentColor" />
      );
    }

    if (hasHalfStar) {
      stars.push(
        <div key="half" className="star-half-wrapper">
          <Star className="star-icon filled" fill="currentColor" />
        </div>
      );
    }

    const remainingStars = 5 - Math.ceil(rating);
    for (let i = 0; i < remainingStars; i++) {
      stars.push(
        <Star key={`empty-${i}`} className="star-icon empty" />
      );
    }

    return stars;
  };

  return (
    <section className="rating-section">
      <div className="rating-container">
        <div className="rating-hero">
          <div className="stars-display-large">
            {renderStars()}
          </div>
          <div className="rating-score-large">{rating} out of 5</div>
          <div className="rating-reviews-count">
            {totalReviews} Genuine Google Reviews
          </div>
        </div>

        <div className="trust-stats">
          <div className="stat-card">
            <div className="stat-icon-wrapper">
              <Users className="stat-icon" />
            </div>
            <div className="stat-number">90/100</div>
            <div className="stat-label">Happy Clients</div>
            <div className="stat-description">Rated 4.5 out of 5 by clients visiting our Kondapur studio</div>
          </div>

          <div className="stat-card">
            <div className="stat-icon-wrapper">
              <Award className="stat-icon" />
            </div>
            <div className="stat-number">5+</div>
            <div className="stat-label">Years of Excellence</div>
            <div className="stat-description">A premium nail salon known for expert nail artistry</div>
          </div>

          <div className="stat-card">
            <div className="stat-icon-wrapper">
              <TrendingUp className="stat-icon" />
            </div>
            <div className="stat-number">100%</div>
            <div className="stat-label">Genuine Reviews</div>
            <div className="stat-description">Trusted choice for luxury nail care in Hyderabad</div>
          </div>
        </div>

        <div className="trust-message">
          <div className="trust-quote">
            <span className="quote-mark">"</span>
            <p className="quote-text">
              True luxury is transparent. Every review you see is a genuine reflection of our dedication 
              to flawless craftsmanship. We don't just finish a service; we personally ask for your feedback 
              to ensure we've exceeded your expectations every single time.
            </p>
            <span className="quote-mark">"</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RatingSection;
